import { beToFeDate, isValidUrl } from '@core/utils';
import {
  AtcDTO,
  ChecklistDTO,
  CreditRequestDTO,
  CreditUseListDTO,
  DigitalSignStartDTO,
  NotificationDTO,
  PositionDTO,
  QuotationBoundariesDTO,
  SurveyDTO,
  WizardStepNextOutputDTO
} from '@api/models/';
import { OutputAdapterService } from '@api/services/output-adapter/output-adapter.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OutputAdapterCustomService extends OutputAdapterService {
  constructor() {
    super();
  }

  getPosition(output: any): PositionDTO {
    output = this.cleanPayload(output);

    if (output.product) {
      output.product = {
        ...output.product,
        netDisbursedAmountToCustomer: output.product.nettoErogatoCqs,
        installment: output.product.rata,
        duration: output.product.durata,
        disbursedAmount: output.product.importoErogato,
        financialTable: output.product.tabellaFinanziaria
      };
    }

    return output;
  }

  getPositionFull(output: any): PositionDTO {
    output = this.cleanPayload(output);

    if (output.product) {
      output.product = {
        ...output.product,
        netDisbursedAmountToCustomer: output.product.nettoErogatoCqs,
        installment: output.product.rata,
        duration: output.product.durata,
        disbursedAmount: output.product.importoErogato
      };
    }

    return output;
  }

  postPositionSave(output: any): string {
    return this.cleanPayload(output);
  }

  getSurvey(output: any): SurveyDTO[] {
    return (output && output.surveys) || [];
  }

  getChecklist(output: any): ChecklistDTO {
    output = this.cleanPayload(output);

    (output as ChecklistDTO).entities.forEach(entity => {
      entity.documents.forEach(doc => {
        if (
          doc.listDocAttribute &&
          !!doc.listDocAttribute.find(x => x.attributeCode === 'VER_WEB_APP')
        ) {
          doc.listDocAttribute.push({
            attributeCode: 'OCR_SCAN',
            mandatory: false,
            operation: 'EQ',
            attributeValue: 'Y',
            done: 'false'
          });
        }
      });
    });

    return output;
  }

  getAtc(output: any): AtcDTO[] {
    return this.cleanPayload(output);
  }

  getNotifications(output: any): NotificationDTO[] {
    return this.cleanPayload(output);
  }

  putWorkflowTaskClose(output: any): WizardStepNextOutputDTO {
    return {
      outcome: output.payload || null,
      messages: (
        (output.metadata && (output.metadata.messages as { code: string }[])) ||
        []
      )
        .map(x => x.code || null)
        .filter(x => !!x)
    };
  }

  getQuotationCreditRequest(output: any): CreditRequestDTO {
    const newOutput = this.cleanPayload<CreditRequestDTO>(output);

    return newOutput
      ? { ...newOutput, expireDate: beToFeDate(newOutput.expireDate) }
      : {};
  }

  getQuotationCreditUse(output: any): CreditUseListDTO {
    const newOutput = this.cleanPayload<CreditUseListDTO>(output);

    if (newOutput && newOutput.uses instanceof Array) {
      newOutput.uses.forEach(
        use => (use.expireDate = beToFeDate(use.expireDate))
      );
    }

    return newOutput;
  }

  getQuotationBoundaries(output: any): QuotationBoundariesDTO {
    return {
      ...output,
      amountSteps: 100
    };
  }

  getQuotationsSimulationBoundaries(output: any): QuotationBoundariesDTO {
    return {
      ...output,
      amountSteps: 100
    };
  }

  postSignStart(output: any): DigitalSignStartDTO {
    if (!isValidUrl(output.providerUrl)) {
      output.completed = true;
    }

    return output;
  }
}
